// Theme-wide components only.
// Gutenberg/ACF blocks are built as independent entries and loaded on demand.
import './header_block/touch.scss';
import {footerEditable} from './footer_block/editable';
import {footer_block} from './footer_block';
import {header_block} from './header_block';

export function indexBlocks() {
  header_block();
  footerEditable();
  footer_block();
}
